/** Shared spring for framed composer text, toggle, and action transitions. */
export const COMPOSER_MOTION_SPRING = { tension: 500, friction: 44, mass: 1 };
//# sourceMappingURL=composerMotion.js.map